import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppContextProvider from './Contexts/AppContextProvider';

// uncomment before pushing to main
if (window.location.protocol !== 'https:' && process.env.NODE_ENV === 'production') {
  window.location.href = `https://${window.location.host}${window.location.pathname}${window.location.search}`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppContextProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </AppContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
